import styles from "./Popup.module.css";
import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Check, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { authData } from "../GetAuth";
import axios from "axios";

export default function AssignDeliveryDriverPopup2({ setLoading, modalClose, bookingIds, onSubmit }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/driver-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose();
    setLoading(true);
    data = { ...data, status: -1 };

    let postData = { driver_id: data?.driver_id, bookingIds: bookingIds };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/assign-bookings", postData, {
      headers: {
        uthorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        modalClose();
        setLoading(false);
        onSubmit(response.data.message);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <DialogTitle id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
      Assign Booking Details To Driver
      <IconButton aria-label="close" onClick={(e) => modalClose(false)} ><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormGroupFull}`}>
          <div className={`FormHalfGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
              <Controller
                control={control}
                {...register("driver_id", { required: "Please select driver" })}
                render={({ field }) => (<Select {...field} label="Select Driver*">
                  {driverList?.map((i) => {
                    return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
                  })}
                </Select>)}
              />
            </FormControl>
            {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => modalClose(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Assign</Button>
        </div>
      </form>
    </DialogContent>
  </>);
}